module.exports = __webpack_public_path__ + "img/contact-us.ec130cf2.png";